import * as React from 'react';

export const Logout = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 1a1 1 0 0 1 .117 1.993L13 3H7a1 1 0 0 0-.993.883L6 4v16a1 1 0 0 0 .883.993L7 21h6a1 1 0 0 1 .117 1.993L13 23H7a3 3 0 0 1-2.995-2.824L4 20V4a3 3 0 0 1 2.824-2.995L7 1h6zm2.74 6.03c.303-.081.624-.015.87.172l.1.088 4 4a1 1 0 0 1 .21.33 1 1 0 0 1 0 .76 1 1 0 0 1-.126.23l-.084.1-4 4a1 1 0 0 1-1.42 0 1 1 0 0 1-.088-1.32l.088-.1 2.3-2.29H11a1 1 0 0 1-.117-1.993L11 11h6.59l-2.3-2.29a1.004 1.004 0 0 1 .45-1.68z"
    />
  </svg>
);
